module.exports = __webpack_public_path__ + "img/img19.1ad7961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img19.png
// module id = 174
// module chunks = 0